export default {
    setList(state, data) {
        state.projects = data
    },
    setProjects(state, data) {
        state.projects = data
    }
}
